import axios from "axios";
import { AuthHeader, url } from "../../utils/_exports";
const apiURL = "lesson-learned";

export interface LessonLearnedImportParams {
	operation_id?: string;
	project_code?: string;
	well_id?: string;
}

export const getLessonLearnedList = async (filter = {}, sort = {}) => {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: { filter: JSON.stringify(filter), sort: JSON.stringify(sort) },
			...AuthHeader,
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

// export function getLessonLearnedListQuery(_filter: any = {}) {
// 	return useQuery({
// 		queryKey: ["lessons_learned"],
// 		queryFn: () =>
// 			axios
// 				.get(`${url}/${apiURL}`, {
// 					params: { filter: JSON.stringify(_filter) },
// 					...AuthHeader,
// 				})
// 				.then((res) => res.data)
// 				.catch((e: any) => {
// 					console.log("Fail to get my lessons learned list", e);
// 					return [];
// 				}),
// 		staleTime: 5 * 60 * 1000,
// 	});
// }

export const addLessonLearnedItem = async (
	data: any,
	user: any,
	tenantKey: any
) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	data.report_type = "lesson_learned";
	data.primary_author = user?.email?.toLowerCase();
	delete data.author;
	data.created_on = new Date();
	data.modified_on = new Date();

	// if (data?.status?.toLowerCase() === "open") {
	// 	data.submitted_on = new Date();
	// }

	// data.report_type = "lesson_learned";
	// data.assigned_by = user?.email;
	// AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	// return new Promise((resolve, reject) => {
	// 	axios
	// 		.post(`${url}/${apiURL}`, { data: data, user: user }, AuthHeader)
	// 		.then((_data: any) => {
	// 			resolve(_data.data);
	// 		})
	// 		.catch((e: any) => {
	// 			console.log("error", e);
	// 			reject(e);
	// 		});
	// });
	try {
		const response = await axios.post(
			`${url}/${apiURL}/add`,
			{ data, user: { email: user?.email, name: user?.name } },
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const updateLessonLearnedItem = async (
	id: string,
	data: any,
	user: any,
	tenantKey: string,
	options: any = { upsert: true, new: true }
) => {
	// ? FOR REFERENCE ONLY (Apply logic in form footer)
	// if (
	// 	initialData?.status?.toLowerCase() === "draft" &&
	// 	data?.status?.toLowerCase() === "open"
	// ) {
	// 	data.submitted_on = new Date();
	// 	console.log("data.submitted_on: ", data.submitted_on, "data: ", data);
	// }
	// if (data?.status?.toLowerCase() === "closed") {
	// 	data.approved_on = new Date();
	// }

	// ! TO BE REMOVED
	// AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	// return new Promise((resolve, reject) => {
	// 	axios
	// 		.put(
	// 			`${url}/${apiURL}/update`,
	// 			{
	// 				filter: { _id: uuid },
	// 				data: data,
	// 				initialData,
	// 				user: userData,
	// 				formList,
	// 				options: { upsert: true, new: true },
	// 			},
	// 			AuthHeader
	// 		)
	// 		.then((_data: any) => {
	// 			resolve(_data.data[0]);
	// 		})
	// 		.catch((e: any) => {
	// 			reject(e);
	// 		});
	// });
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	data.modified_on = new Date();
	try {
		const response = await axios.put(
			`${url}/${apiURL}/update`,
			{
				filter: { _id: id },
				data,
				user: { email: user?.email, name: user?.name },
				options,
			},
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const deleteLessonLearnedItem = async (id: any, tenantKey: any) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const response = await axios.post(
			`${url}/${apiURL}/delete`,
			{
				filter: { _id: id },
			},
			AuthHeader
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const downloadLessonLearnedImportTemplate = async (
	tenantKey?: string,
	params?: LessonLearnedImportParams
) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const response = await axios.get(`${url}/${apiURL}/import-template`, {
			params,
			...AuthHeader,
			responseType: "blob",
		});
		const blob = new Blob([response.data], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		const link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.download = "lessons_learned_template.xlsx";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(link.href);
	} catch (error) {
		throw error;
	}
};

export const importLessonLearnedFromExcel = async (
	file: File,
	tenantKey?: string,
	params?: LessonLearnedImportParams
) => {
	AuthHeader.headers = { ...AuthHeader.headers, tenantKey: tenantKey };
	try {
		const formData = new FormData();
		formData.append("file", file);
		const response = await axios.post(`${url}/${apiURL}/import`, formData, {
			params,
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		if (error.response) {
			throw error.response.data;
		}
		throw error;
	}
};
